import { ArrowLeft, Building2 } from 'lucide-react';
import { WorkerProject } from '../../types/worker.types';

interface WorkerHeaderProps {
  project: WorkerProject;
  onBack?: () => void;
  showBackButton?: boolean;
  title?: string;
}

export function WorkerHeader({ 
  project, 
  onBack, 
  showBackButton = false, 
  title 
}: WorkerHeaderProps) {
  return (
    <header className="bg-white border-b border-gray-200 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {showBackButton && onBack && (
            <button
              onClick={onBack}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <ArrowLeft className="h-5 w-5 text-gray-600" />
            </button>
          )}
          
          <div className="flex items-center space-x-3">
            {project.config.branding.show_company_logo && project.company?.logo_url ? (
              <img 
                src={project.company.logo_url} 
                alt={project.company.name}
                className="h-8 w-8 rounded-full object-cover"
              />
            ) : (
              <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
                <Building2 className="h-5 w-5 text-blue-600" />
              </div>
            )}
            
            <div>
              <h1 className="text-lg font-semibold text-gray-900">
                {title || project.name}
              </h1>
              {project.company && !title && (
                <p className="text-sm text-gray-500">
                  {project.company.name}
                </p>
              )}
            </div>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <div className="h-2 w-2 rounded-full bg-green-500"></div>
          <span className="text-sm text-gray-600">En ligne</span>
        </div>
      </div>
    </header>
  );
}